// The official AVRASTRO logo as inlined data URLs (generated by tools/brand/build-assets.py from
// brand/vero-logo-source.png — cropped and resampled only, never redrawn).
import LOGO from '../assets/brand/vero-logo.webp';
import LOGO_2X from '../assets/brand/vero-logo@2x.webp';
import MARK from '../assets/brand/vero-mark.webp';
import WORDMARK from '../assets/brand/vero-wordmark.webp';

export const VERO_LOGO = LOGO;
export const VERO_LOGO_2X = LOGO_2X;
export const VERO_MARK = MARK;
export const VERO_WORDMARK = WORDMARK;
